var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrecio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.191,
    height: 41.362,
    viewBox: "0 0 48.191 41.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.493,52.538H44.346V45.649a5.106,5.106,0,0,0-5.1-5.1H38.189l.01-2.56A3.442,3.442,0,0,0,34.76,34.55H4.181A4.183,4.183,0,0,0,0,38.671v33.8a3.442,3.442,0,0,0,3.439,3.439H39.257a5.106,5.106,0,0,0,5.1-5.1v-6.9H45.5a2.691,2.691,0,0,0,2.688-2.688v-6A2.706,2.706,0,0,0,45.493,52.538ZM4.181,36.922H34.76a1.067,1.067,0,0,1,1.067,1.058l-.01,2.57H4.181a1.814,1.814,0,0,1,0-3.627ZM41.974,70.8a2.733,2.733,0,0,1-2.728,2.728H3.43a1.069,1.069,0,0,1-1.067-1.067V42.506a4.163,4.163,0,0,0,1.819.415H39.247a2.733,2.733,0,0,1,2.728,2.728v6.889H33.88a2.691,2.691,0,0,0-2.688,2.688v6a2.691,2.691,0,0,0,2.688,2.688h8.094Zm3.835-9.577a.312.312,0,0,1-.316.316H33.89a.312.312,0,0,1-.316-.316v-6a.318.318,0,0,1,.316-.316h11.6a.318.318,0,0,1,.316.316v6Z",
    transform: "translate(0 -34.55)",
    fill: "#0f192d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecio);
export default __webpack_public_path__ + "static/media/precio.3f269e1d5b734b1d6943cd5c6508c3e9.svg";
export { ForwardRef as ReactComponent };